import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: "currentOnly",
    fallbackLng: "ko-KR",
    debug: false,

    interpolation: {
      escapeValue: false,
    },
    parseMissingKeyHandler(key = "") {
      const keySeparator = "~~";
      const value = key.includes(keySeparator) ? key.split(keySeparator)[1] : key;
      return value;
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
